/**
 * web/src/games/RoundCard.tsx — one round, read at a glance (card eq92fFXqQUuP).
 *
 * The question, whose turn it is, and how many of today's three are left.
 * Nothing else: the answer, the guess and the verdict are each somebody else's
 * to hold until the server says otherwise, and this card never renders a field
 * the server did not send.
 */
import type { GuessMeRound } from '../../../shared/types';
import { GUESS_ME_CATEGORY_LABELS, GUESS_ME_DAILY_CAP } from '../../../shared/types';

interface RoundCardProps {
  round: GuessMeRound;
  partnerName: string;
}

export function RoundCard({ round, partnerName }: RoundCardProps) {
  /* Explicit copy per STATE, not "everything after open is waiting": a
     revealed round used to tell the answerer to keep waiting and the guesser
     it was their turn, right above the result saying otherwise (sol review
     2026-10-19). */
  const answerer = round.myRole === 'answerer';
  const line =
    round.state === 'revealed'
      ? 'Revealed.'
      : round.state === 'B_locked'
        ? 'Both in — scoring…'
        : round.state === 'A_locked'
          ? (answerer
            ? 'Your answer is locked in — waiting on their guess.'
            : `${partnerName} has answered. Your guess.`)
          : (answerer
            ? 'You answer first. They guess what you said.'
            : `Waiting for ${partnerName} to answer…`);

  return (
    <article className="gm-card" id="gm-card" data-state={round.state} data-role={round.myRole}>
      <p className="gm-card-meta">
        <span className="gm-card-cat" id="gm-category">
          {GUESS_ME_CATEGORY_LABELS[round.category] ?? round.category}
        </span>
        <span className="gm-card-left" id="gm-left" data-left={round.todayLeft}>
          {round.todayLeft} of {GUESS_ME_DAILY_CAP} left today
        </span>
      </p>
      <p className="gm-card-question" id="gm-question">
        {round.question}
      </p>
      <p className="gm-card-turn" id="gm-turn">
        {line}
      </p>
    </article>
  );
}
